import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { Tab } from "react-bootstrap";
import Planos from "./Planos";
import Canais from "./Canais";
import Numeros from './Numeros';
import * as FcIcons from "react-icons/fc";

import './styles.css';
import Stbs from './Stbs';
import Plataformas from './Plataformas';

const Tv = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    const [activeTab, setActiveTab] = useState('/canais');

    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };

    return (
        <div><br />
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav fill variant="tabs" defaultActiveKey="/canais">
                    <Nav.Item>
                        <Nav.Link eventKey="/canais">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcMultipleDevices /></h4>
                                <h5>Canais de TV</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/planos">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcCurrencyExchange /></h4>
                                <h5>Planos</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/numeracao">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcFinePrint /></h4>
                                <h5>Numeração dos canais</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/stbs">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcServices /></h4>
                                <h5>STBs</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/managers">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcServices /></h4>
                                <h5>Beenius/Middleware</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="/canais">
                        <Canais />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/planos">
                        <Planos />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/numeracao">
                        <Numeros />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/stbs">
                        <Stbs />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/managers">
                        <Plataformas />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}
export default Tv;